import React from 'react';

import type { Tag } from '../../../../core/data-sources/frapi/data-types.js';

import { makeTagTitle } from '../articles/helpers.js';
import { replacedTagUrl } from './helpers.js';

type TagLinkButtonProps = {
  filterTags: string;
  tag: Tag;
  section: string;
  presetTerm?: string;
};

const FilterLinkButton: React.FC<TagLinkButtonProps> = ({
  filterTags,
  section,
  tag,
  presetTerm,
}) => {
  const tagTitle = makeTagTitle(tag.title);

  const pathname = decodeURIComponent(window.location.href);
  const lastTag = tag.id === filterTags;

  const searchUrl = presetTerm
    ? `/sok?phrase=${presetTerm}&section=${section}`
    : '/sok';

  return (
    <a
      className="filter-button active link"
      href={!lastTag ? replacedTagUrl(pathname, tag.id) : searchUrl}
    >
      {tagTitle}
    </a>
  );
};

export default FilterLinkButton;
